import { useContext, useEffect, useRef } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { AppContext } from '../../context/App';
import { Content } from '../Layout';

export function SsoExchange() {
  const context = useContext(AppContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasExchanged = useRef(false);

  const code = searchParams.get('code');
  const state = searchParams.get('state');

  useEffect(() => {
    if (!code || !state) {
      context?.authentication.codeVerifierStorage.clearCodeVerifier();
      navigate('/login', { replace: true });
      return;
    }

    if (hasExchanged.current) return;
    hasExchanged.current = true;

    const appRedirectTo = sessionStorage.getItem('appRedirectTo');
    if (appRedirectTo) {
      const params = new URLSearchParams(window.location.search);
      params.set('redirectTo', appRedirectTo);
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}?${params}`,
      );
      sessionStorage.removeItem('appRedirectTo');
    }

    const codeVerifier =
      context?.authentication.codeVerifierStorage.getCodeVerifier();

    if (!codeVerifier) {
      navigate('/login?ssoError=true', { replace: true });
      return;
    }

    context?.authentication
      .ssoExchange?.(code, state, codeVerifier)
      ?.catch(() => {
        navigate('/login?ssoError=true', { replace: true });
      });
  }, [code, state, context, navigate]);

  return <Content loading />;
}
